import React from 'react';

import styles from './AdSlot.scss';

const StaticAdSlot = ({ link, src }) => {
  return (
    <div className="AdSlot AdSlot--static">
      <label className="AdSlot__label">Advertisement</label>
      <a href={link} target="_blank">
        <img src="AdSlot__static-image" src={src} />
      </a>
    </div>
  );
};

export default StaticAdSlot;
